import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH, CMS_PATH } from 'config';
import Logo from 'ui-component/Logo';
import useAuth from 'hooks/useAuth';

import { useCookies } from 'react-cookie';

import logo from '../../../assets/images/njd_logo.png';

// ==============================|| MAIN LOGO ||============================== //

// ロゴ画像指定

const LogoSection = () => {
  const { tokens } = useAuth();
  const [cookies] = useCookies();

  // 現在のサイトのドメインを取得
  const currentOrigin = window.location.origin;

  // const imgSrc = `${process.env.REACT_APP_HOME_URL}wp-content/uploads/2025/01/2024_12_%E8%8B%AB%E5%B0%8F%E7%89%A7%E3%83%AD%E3%82%B4W-e1735549733584.png`;
  const targetUrl = `${process.env.REACT_APP_HOME_URL}?foidtk=${cookies?.foidtk}&referer=${currentOrigin}`;

  return (
    <a href={targetUrl} rel="noopener noreferrer" aria-label="tomamin">
      <img src={logo} alt="logo" width="230" style={{ marginRight: '10px' }} />
    </a>
  );
};

export default LogoSection;
